import Vue from 'vue';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_green.css';
import FlatPickr from 'vue-flatpickr-component';

Vue.component('FlatPickr', FlatPickr);

export default FlatPickr;
